const heroStats = [
  { num: '120+', label: '收录恋爱甜番' },
  { num: 'Top5', label: '每周心动榜单' },
  { num: '4 种', label: '心动口味分区' },
  { num: '持续', label: '更新推荐合集' },
];

export default function Hero() {
  return (
    <section id="home" className="relative flex items-center justify-center min-h-[92vh] overflow-hidden">
      <img
        src="https://readdy.ai/api/search-image?query=Wide%20anime%20illustration%20of%20a%20warm%20romantic%20sunset%20over%20a%20pastel%20pink%20and%20peach%20sky%2C%20cherry%20blossom%20petals%20drifting%20in%20the%20soft%20breeze%2C%20silhouettes%20of%20a%20young%20couple%20standing%20close%20together%20on%20a%20gentle%20hill%2C%20dreamy%20bokeh%20lights%2C%20tender%20heartwarming%20atmosphere%2C%20soft%20pastel%20color%20palette%2C%20clean%20modern%20anime%20key%20visual%2C%20high%20quality%20digital%20art&width=1600&height=900&seq=hero-cover&orientation=landscape"
        alt="恋爱甜番心动夕阳插画背景"
        className="absolute inset-0 w-full h-full object-cover"
      />
      <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/25 to-black/40"></div>

      <div className="relative z-10 w-full max-w-4xl mx-auto px-4 md:px-6 py-24 md:py-28 text-center">
        <span className="inline-flex items-center gap-2 px-3 py-1.5 text-sm text-white bg-white/15 backdrop-blur-sm border border-white/30 rounded-full mb-6">
          <i className="ri-hearts-fill text-amber-300"></i>
          恋爱甜番 · 心动合集持续更新中
        </span>
        <h1 className="font-heading text-4xl md:text-6xl text-white leading-tight animate-fade-up">
          羞羞的动漫
        </h1>
        <p className="mt-3 text-lg md:text-2xl text-white/90 font-label tracking-wide animate-fade-up">
          高甜 · 纯爱 · 狗粮 · 暧昧心动，挑一部就能开刷
        </p>
        <p className="mt-4 max-w-2xl mx-auto text-sm md:text-base text-white/80 leading-relaxed">
          这里整理着让人心跳加速的恋爱番剧。甜番、纯爱、狗粮与暧昧心动全都有，附上甜度测评与心动名场面，帮你快速找到想看的下一部。
        </p>

        <div className="mt-8 flex flex-col sm:flex-row items-center justify-center gap-3 md:gap-4">
          <a
            href="#recommend"
            className="inline-flex items-center justify-center gap-2 px-7 py-3 text-sm md:text-base font-medium text-background-50 bg-primary-500 hover:bg-primary-600 rounded-md whitespace-nowrap transition-colors"
          >
            挑一部开刷
            <i className="ri-arrow-down-line"></i>
          </a>
          <a
            href="#category"
            className="inline-flex items-center justify-center gap-2 px-7 py-3 text-sm md:text-base font-medium text-white border border-white/40 hover:bg-white/15 rounded-md whitespace-nowrap transition-colors"
          >
            按口味浏览
            <i className="ri-compass-3-line"></i>
          </a>
        </div>

        <dl className="mt-12 grid grid-cols-2 sm:grid-cols-4 gap-3 md:gap-4">
          {heroStats.map((s) => (
            <div key={s.label} className="rounded-lg bg-white/10 backdrop-blur-sm border border-white/20 px-3 py-4">
              <dt className="sr-only">{s.label}</dt>
              <dd className="font-heading text-2xl md:text-3xl text-white">{s.num}</dd>
              <p className="mt-1 text-xs md:text-sm text-white/80">{s.label}</p>
            </div>
          ))}
        </dl>
      </div>
    </section>
  );
}